export const isVersionGreaterThan = (version: string, targetVersion: string) => {
  const versionParts = version.split('.').map(Number);
  const targetVersionParts = targetVersion.split('.').map(Number);

  for (let i = 0; i < versionParts.length || i < targetVersionParts.length; i++) {
    const versionPart = versionParts[i] || 0;
    const targetVersionPart = targetVersionParts[i] || 0;

    if (versionPart > targetVersionPart) {
      return true;
    } else if (versionPart < targetVersionPart) {
      return false;
    }
  }

  return false;
};

export const isVersionGreaterOrEqualThan = (version: string, targetVersion: string) => {
  const versionParts = version.split('.').map(Number);
  const targetVersionParts = targetVersion.split('.').map(Number);

  for (let i = 0; i < versionParts.length || i < targetVersionParts.length; i++) {
    const versionPart = versionParts[i] || 0;
    const targetVersionPart = targetVersionParts[i] || 0;

    if (versionPart > targetVersionPart) {
      return true;
    } else if (versionPart < targetVersionPart) {
      return false;
    }
  }

  return true;
};
